import * as Sentry from '@sentry/browser';
import checkDispatcher from './Dispatcher';
import { getConfig } from 'helpers/Config';

const sentryWrapper = {
    /**
     * @type {Sentry} Sentry instance
     */
    Sentry,
    /**
     * @type {Boolean}
     */
    isInitialized: false,
};

function beforeSend(event, hints) {
    const isFromMapbox = hints?.originalException?.stack?.includes('mapbox');

    const doNotSendEventConditions = [
        // Avoid confusing errors of MA VPN
        // Delete this when the VPN will be not used
        event?.request?.url?.indexOf('haussmann.meilleursagents.net') >= 0,

        // Prevent sending Safari known error of mapbox aborting multiple tiles fetch
        // See https://github.com/mapbox/mapbox-gl-js/issues/8480
        isFromMapbox &&
            event?.reason?.code === 20 &&
            event?.reason?.name === 'AbortError' &&
            event?.reason?.message === 'Fetch is aborted',
    ];

    if (doNotSendEventConditions.some((condition) => condition)) {
        return null;
    }

    return event;
}

const dsn = getConfig('SENTRY_DSN');

export function initSentry() {
    if (dsn && checkDispatcher('sentry_estima')) {
        sentryWrapper.isInitialized = true;

        Sentry.init({
            dsn,
            environment: getConfig('ENVIRONMENT'),
            blacklistUrls: ['mapbox-gl'],
            ignoreErrors: [
                'Non-Error promise rejection captured with value: Object Not Found Matching',
            ],
            beforeSend(event, hints) {
                try {
                    return beforeSend(event, hints);
                } catch {
                    return event;
                }
            },
        });
    }
}

export default sentryWrapper;
